import type { ReactNode } from 'react';

interface VariableCategoryGridProps {
    icon: string;
    iconColor: string;
    label: string;
    prefix: string;
    children: ReactNode;
}

const VariableCategoryGrid = ({ icon, iconColor, label, prefix, children }: VariableCategoryGridProps) => (
    <div>
        <div className="display-flex align-items-center gap-5 margin-bottom-10">
            <span className={`uikit-icon ${icon} ${iconColor} text-size-12`} />
            <span className="text-size-12 text-bold text-uppercase text-color-dark">
                {label} <span className="text-color-gray font-family-mono text-size-11">({prefix}.&lt;var&gt;)</span>
            </span>
        </div>
        <div className="display-grid gap-10" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
            {children}
        </div>
    </div>
);

export default VariableCategoryGrid;
